import { createAction } from '@reduxjs/toolkit';

import { File } from 'src/v2/features/sharedEntity/types';

export const downloadAsFile = createAction<File>('sharedEntity/downloadAsFile');
